import React from "react";
import denting from "../../Assets/Images/Denting Painting (1).png";
import hydrotech from "../../Assets/Images/hydrotech-logo.png";
import mechanical from "../../Assets/Images/Mechanical Works.png";
import automotive from "../../Assets/Images/Automotive Training.png";
import bg_img from "../../Assets/Images/service_bg.png";
import hoverImg1 from "../../Assets/Images/HoverImg1.png";
import hoverImg2 from "../../Assets/Images/HoverImg2.png";
import hoverImg3 from "../../Assets/Images/HoverImg3.png";
import hoverImg4 from "../../Assets/Images/HoverImg4.png";

const services = [
  {
    img: denting,
    hoverImg: hoverImg1,
    title: "DENTING & PAINTING",
  },
  {
    img: hydrotech,
    hoverImg: hoverImg2,
    title: "CARBON CLEANING",
  },
  {
    img: mechanical,
    hoverImg: hoverImg3,
    title: "MECHANICAL WORKS",
  },
  {
    img: automotive,
    hoverImg: hoverImg4,
    title: "AUTOMOTIVE TRAINING",
  },
];

const Service = () => {
  return (
    <div className="w-full bg-white py-10">
      <div className="px-4 md:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {services.map((service, index) => (
          <div
            key={index}
            style={{
              backgroundImage: `url(${bg_img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="group flex flex-col items-center justify-center border p-6 transition-all duration-300"
          >
            {/* Image Swap on Hover */}
            <img
              src={service.img}
              alt={service.title}
              className={`object-contain mb-4 h-20 w-20 ${
                index === 1 ? "w-48" : ""
              } group-hover:hidden`}
            />
            <img
              src={service.hoverImg}
              alt={service.title}
              className={`object-contain mb-4 h-20 w-20 ${
                index === 1 ? "w-48" : ""
              } hidden group-hover:block`}
            />

            <h3 className="font-orbitron font-semibold text-lg leading-[24px] tracking-[2px] align-middle uppercase">
              {service.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
